<app-kontable
      #table
      id="touch-point-user-table"
      title="{{ 'promotion.touchPointUser' | translate }}"
      *ngIf="touchPointsUsersData && listStates.length > 0"
      [columns]="['userId', 'userLogin', 'tpCode', 'tpDescription', { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterOptions: {values: listStates} }]"
      [titles]="['promotion.userId', 'promotion.login', 'promotion.tpCode', 'promotion.tpDesc']"
       [showRecoverButton]="true"
       [showDetailsButton]="false"
       [showReport]="false"
       [showGlobalFilter]="false"
       [showAddButton]="true"
       [showEditButton]="true"
       [showDeleteButton]="true"
       [showInfoButton]="false"
       [source]="touchPointsUsersData"
       [fixedFilters]="initialFilters"
       (onAdd)="showAddDialog()"
       (onEdit)="showEditDialog($event)"
       (onRemove)="delete($event)"
       (onRecover)="recover($event)">
       <ng-template #stateTemplate let-row>
        <span *ngIf="row.flg_state == '0'"><span class="status-dot status-dot-green"></span>{{ 'common.active' | translate }}</span>
        <span *ngIf="row.flg_state == '1'"><span class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span> {{ 'common.inactive' | translate }}</span>
       </ng-template>
</app-kontable>

<p-dialog
      *ngIf="displayDialog"
      [(visible)]="displayDialog"
      [modal]="true"
      [header]="dialogMode === 'add' ? ('promotion.addTouchPointUser' | translate) : ('promotion.editTouchPointUser' | translate)"
      [minWidth]="400"
      [draggable]="false"
      [resizable]="false"
      (onHide)="displayDialog = false">

  <div class="card">
    <div class="ui-g ui-fluid">

      <div class="ui-g-12 ui-md-12">
        <span class="label required">{{ 'promotion.tpCode' | translate }}</span>
        <p-dropdown
          data-testid="touch-point-user-tp-code"
          [options]="touchPoints"
          [(ngModel)]="formData.ochannel_id"
          [autoWidth]="false"
          [style]="{'width':'100%'}"
          [placeholder]="'promotion.selectTouchPoint' | translate">
        </p-dropdown>
        <div class="ui-message ui-messages-error ui-corner-all" *ngIf="submitted && !formData.ochannel_id">
          {{ 'common.required_error' | translate }}
        </div>
      </div>

      <div class="ui-g-12 ui-md-12">
        <span class="label required">{{ 'promotion.login' | translate }}</span>
        <p-dropdown
          data-testid="touch-point-user-login"
          [options]="users"
          [(ngModel)]="formData.user_id"
          [autoWidth]="false"
          [disabled]="dialogMode === 'edit'"
          [placeholder]="'promotion.selectUser' | translate"
          [style]="{'width':'100%'}">
        </p-dropdown>
        <div class="ui-message ui-messages-error ui-corner-all" *ngIf="submitted && !formData.user_id">
          {{ 'common.required_error' | translate }}
        </div>
      </div>

      <!-- KS-7923: nascosto la checkbox di flgDefault -->
      <!-- <div class="ui-g-12 ui-md-12">
        <p-checkbox
          [(ngModel)]="formData.flg_default"
          [binary]="true"
          label="{{ 'promotion.flgDefault' | translate }}">
        </p-checkbox>
      </div> -->

    </div>

    <div class="ui-g">
      <div class="ui-g-12 ui-md-12" style="text-align: right;">
        <button
          pButton
          icon="fa fa-check"
          iconPos="right"
          type="button"
          class="k-generic-btn"
          label="{{ 'common.save' | translate }}"
          (click)="save()">
        </button>
        <button
          pButton
          icon="fa fa-times"
          iconPos="right"
          type="button"
          class="k-generic-btn"
          label="{{ 'common.cancel' | translate }}"
          (click)="displayDialog = false">
        </button>
      </div>
    </div>

  </div>

</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point-user/touch-point-user.component.html